import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from '@angular/core';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AssignmentConfigurationDto } from 'app/Models/AssignmentConfigurationDto';
import {
  ResourceEditConfigurationDto,
  JobEditConfigurationDto,
} from 'app/Models/EditConfigurationVM';
import {
  ResourceViewConfigurationDto,
  JobViewConfigurationDto,
} from 'app/Models/ViewConfigurationVM';
import { NgxSpinnerService } from 'ngx-spinner';
import { BookingConfigurationDto } from 'app/Models/BookingConfigurationDto';
import { ModalOptions, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { RoleTypeEnum } from 'app/shared/enum';
import {
  JobAddConfigurationDto,
  ResourceAddConfigurationDto,
} from 'app/Models/AddConfigurationVM';
import {
  JobDeleteConfigurationDto,
  ResourceDeleteConfigurationDto,
} from 'app/Models/DeleteConfigurationVM';
import {
  JobReplaceConfigurationDto,
  ResourceReplaceConfigurationDto,
} from 'app/Models/ReplaceConfigurationVM';
import {
  JobReplaceAllConfigurationDto,
  ResourceReplaceAllConfigurationDto,
} from 'app/Models/ReplaceAllConfigurationVM';
import { ROLE_LAYERS, RoleConfigService } from '../role-config.service';
import { RoleVM } from 'app/Models/RoleVM';
import { SharedServicesService } from 'app/shared/sharedservices/shared-services.service';
import { RoleApprovalConfigurationVM } from 'app/Models/RoleApprovalConfigurationVM';
import { FeatureLevelConfigVM } from 'app/Models/FeatureLevelConfigVM';
import {
  AppMemoryService,
  DATA_KEY,
} from 'app/shared/sharedservices/appmem.service';
import { MasterDataService } from '../master-data.service';
import { RoleReportConfigurationVM } from 'app/Models/RoleReportConfigurationVM';

@Component({
  selector: 'app-add-role-configuration',
  templateUrl: './add-role-configuration.component.html',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./add-role-configuration.component.scss'],
})
export class AddRoleConfigurationComponent implements OnInit {
  @Output() onScroll = new EventEmitter<any>();
  approvalArrDtoForSubmission: RoleApprovalConfigurationVM[] = [];
  enableAddInApprovalLayer: boolean = true;
  panelOpenState: boolean;
  // #region Global Declaration
  formGroup: FormGroup;

  // // Local Arrays
  // dataIncludeJobCode: any = [];
  // dataJobCode: any = [];
  // dataJobStatus: any = [];
  // dataJobCategory: any = [];
  // dataActivityType: any = [];
  // dataSubManagementUnit: any = [];
  // dataSubServiceLine: any = [];
  // dataServiceLine: any = [];
  // dataManagementUnit: any = [];
  // dataOperatingUnit: any = [];
  // dataBusinessUnit: any = [];
  // dataJobCostCenter: any = [];
  // dataResCostCenter: any = [];
  // dataDepartment: any = [];
  // dataCompetency: any = [];
  // dataEconomicLocation: any = [];
  // dataCompanyCode: any = [];
  // dataLegalEntity: any = [];
  // dataManageCountry: any = [];
  // dataSubArea: any = [];

  modalOption: ModalOptions = {};
  modalRef: BsModalRef;
  // Report Config V1
  assignmentManageReportList = [];
  assignmentManageReportSelectedItems = [];
  // Assignment Configuration
  assignmentSubAreaList = [];
  assignmentManageCountryList = [];
  assignmentLegalEntityList = [];
  assignmentBusinessUnitList = [];
  assignmentOperatingUnitList = [];
  assignmentManagementUnitList = [];
  assignmentDepartmentList = [];
  assignmentServiceLineList = [];
  assignmentSubServiceLineList = [];
  assignmentSubManagementUnitList = [];
  assignmentLevelList = [];
  assignmentEngagementCompetencyList = [];
  assignmentCompanyCodeList = [];
  assignmentEconomicLocationList = [];
  assignmentRankList = [];

  // Add Configuration
  resAddSubAreaList = [];
  resAddManageCountryList = [];
  resAddCompanyCodeList = [];
  resAddEcLocationList = [];
  resAddServiceLineList = [];
  resAddSubServiceLineList = [];
  resAddEngCompetencyList = [];
  resAddHRDeptList = [];
  resAddCostCenterList = [];
  resAddRankList = [];

  jobAddSubAreaList = [];
  jobAddManageCountryList = [];
  jobAddLegalEntityList = [];
  jobAddCompanyCodeList = [];
  jobAddBusinessUnitList = [];
  jobAddEconomicLocationList = [];
  jobAddEngCompetencyList = [];
  jobAddServiceLineList = [];
  jobAddSubServiceLineList = [];
  jobAddSubManagementUnitList = [];
  jobAddRankList = [];
  jobAddJobCategoryList = [];
  jobAddJobStatusList = [];
  jobAddJobStatusBookingList = [];
  jobAddJobCodeList = [];
  jobAddIncludeJobCodeList = [];
  jobAddCostCenterList = [];
  // End

  // Delete Configuration
  resDeleteSubAreaList = [];
  resDeleteManageCountryList = [];
  resDeleteCompanyCodeList = [];
  resDeleteEcLocationList = [];
  resDeleteServiceLineList = [];
  resDeleteSubServiceLineList = [];
  resDeleteEngCompetencyList = [];
  resDeleteHRDeptList = [];
  resDeleteCostCenterList = [];
  resDeleteRankList = [];

  jobDeleteSubAreaList = [];
  jobDeleteManageCountryList = [];
  jobDeleteLegalEntityList = [];
  jobDeleteCompanyCodeList = [];
  jobDeleteEcoLocationsList = [];
  jobDeleteEngCompetencyList = [];
  jobDeleteBusinessUnitList = [];
  jobDeleteServiceLineList = [];
  jobDeleteSubServiceLineList = [];
  jobDeleteSubManagementUnitList = [];
  jobDeleteRankList = [];
  jobDeleteJobCategoryList = [];
  jobDeleteJobStatusList = [];
  jobDeleteJobStatusBookingList = [];
  jobDeleteJobCodeList = [];
  jobDeleteIncludeJobCodeList = [];
  jobDeleteCostCenterList = [];
  // End

  // Replace Configuration
  resReplaceSubAreaList = [];
  resReplaceManageCountryList = [];
  resReplaceCompanyCodeList = [];
  resReplaceEcLocationList = [];
  resReplaceServiceLineList = [];
  resReplaceSubServiceLineList = [];
  resReplaceEngCompetencyList = [];
  resReplaceHRDeptList = [];
  resReplaceCostCenterList = [];
  resReplaceRankList = [];

  jobReplaceSubAreaList = [];
  jobReplaceManageCountryList = [];
  jobReplaceLegalEntityList = [];
  jobReplaceCompanyCodeList = [];
  jobReplaceEcoLocationList = [];
  jobReplaceEngCompetencyList = [];
  jobReplaceBusinessUnitList = [];
  jobReplaceServiceLineList = [];
  jobReplaceSubServiceLineList = [];
  jobReplaceSubManagementUnitList = [];
  jobReplaceRankList = [];
  jobReplaceJobCategoryList = [];
  jobReplaceJobStatusList = [];
  jobReplaceJobStatusBookingList = [];
  jobReplaceJobCodeList = [];
  jobReplaceIncludeJobCodeList = [];
  jobReplaceCostCenterList = [];
  // End

  // Replace All Configuration
  resReplaceAllSubAreaList = [];
  resReplaceAllManageCountryList = [];
  resReplaceAllCompanyCodeList = [];
  resReplaceAllEcLocationList = [];
  resReplaceAllServiceLineList = [];
  resReplaceAllSubServiceLineList = [];
  resReplaceAllEngCompetencyList = [];
  resReplaceAllRankList = [];
  resReplaceAllHRDeptList = [];
  resReplaceAllCostCenterList = [];

  jobReplaceAllSubAreaList = [];
  jobReplaceAllManageCountryList = [];
  jobReplaceAllLegalEntityList = [];
  jobReplaceAllCompanyCodeList = [];
  jobReplaceAllEcoLocationList = [];
  jobReplaceAllEngCompetencyList = [];
  jobReplaceAllBusinessUnitList = [];
  jobReplaceAllServiceLineList = [];
  jobReplaceAllSubServiceLineList = [];
  jobReplaceAllSubManagementUnitList = [];
  jobReplaceAllRankList = [];
  jobReplaceAllJobCategoryList = [];
  jobReplaceAllJobStatusList = [];
  jobReplaceAllJobStatusBookingList = [];
  jobReplaceAllJobCodeList = [];
  jobReplaceAllIncludeJobCodeList = [];
  jobReplaceAllCostCenterList = [];
  // End

  // Edit
  resEditSubAreaList = [];
  resEditManageCountryList = [];
  resEditCompanyCodeList = [];
  resEditEcLocationList = [];
  resEditServiceLineList = [];
  resEditSubServiceLineList = [];
  resEditEngCompetencyList = [];
  resEditHRDeptList = [];
  resEditCostCenterList = [];
  resEditRankList = [];

  jobEditSubAreaList = [];
  jobEditManageCountryList = [];
  jobEditLegalEntityList = [];
  jobEditBusinessUnitList = [];
  jobEditServiceLineList = [];
  jobEditSubServiceLineList = [];
  jobEditSubManagementUnitList = [];
  jobEditRankList = [];
  jobEditJobCategoryList = [];
  jobEditJobStatusList = [];
  jobEditJobStatusBookingList = [];
  jobEditJobCodeList = [];
  jobEditIncludeJobCodeList = [];
  jobEditCompanyCodeList = [];
  jobEditEconomicLocationList = [];
  jobEditEngagementCompetencyList = [];
  jobEditCostCenterList = [];

  // End

  // View

  resViewSubAreaList = [];
  resViewManageCountryList = [];
  resViewCompanyCodeList = [];
  resViewEcLocationList = [];
  resViewServiceLineList = [];
  resViewSubServiceLineList = [];
  resViewEngCompetencyList = [];
  resViewHRDeptList = [];
  resViewCostCenterList = [];
  // resViewRankList = [];

  jobViewSubAreaList = [];
  jobViewManageCountryList = [];
  jobViewLegalEntityList = [];
  jobViewCompanyCodeList = [];
  jobViewBusinessUnitList = [];
  jobViewEconomicLocationList = [];
  jobViewServiceLineList = [];
  jobViewSubServiceLineList = [];
  jobViewSubManagementUnitList = [];
  jobViewEngagementCompetencyList = [];
  // jobViewRankList = [];
  jobViewJobCategoryList = [];
  jobViewJobStatusList = [];
  jobViewJobStatusBookingList = [];
  jobViewJobCodeList = [];
  jobViewCostCenterList = [];
  jobViewIncludeJobCodeList = [];

  // End

  assignmentSubAreaSelectedItems = [];
  assignmentManageCountrySelectedItems = [];
  assignmentBusinessUnitSelectedItems = [];
  assignmentEconomicLocationSelectedItems = [];
  assignmentLegalEntitySelectedItems = [];
  assignmentCompanyCodeSelectedItems = [];
  assignmentServiceLineSelectedItems = [];
  assignmentSubServiceLineSelectedItems = [];
  assignmentSubManagementUnitSelectedItems = [];
  assignmentEngagementCompetencySelectedItems = [];
  assignmentLevelSelectedItems = [];
  assignmentRankSelectedItems = [];
  assignmentOperatingUnitSelectedItems = [];
  assignmentManagementUnitSelectedItems = [];
  assignmentDepartmentSelectedItems = [];
  // Add Configuration
  resAddSubAreaSelectedItems = [];
  resAddManageCountrySelectedItems = [];
  resAddEcLocationSelectedItems = [];
  resAddCompanyCodeSelectedItems = [];
  resAddServiceLineSelectedItems = [];
  resAddSubServiceLineSelectedItems = [];
  resAddEngCompetencySelectedItems = [];
  resAddHRDeptSelectedItems = [];
  resAddCostCenterSelectedItems = [];
  resAddRankSelectedItems = [];

  jobAddSubAreaSelectedItems = [];
  jobAddManageCountrySelectedItems = [];
  jobAddBusinessUnitSelectedItems = [];
  jobAddLegalEntitySelectedItems = [];
  jobAddCompanyCodeSelectedItems = [];
  jobAddEconomicLocationsSelectedItems = [];
  jobAddEngCompetencySelectedItems = [];
  jobAddServiceLineSelectedItems = [];
  jobAddSubServiceLineSelectedItems = [];
  jobAddSubManagementUnitSelectedItems = [];
  jobAddRankSelectedItems = [];
  jobAddJobCategorySelectedItems = [];
  jobAddJobStatusSelectedItems = [];
  jobAddJobStatusBookingSelectedItems = [];
  jobAddJobCodeSelectedItems = [];
  jobAddIncludeJobCodeSelectedItems = [];
  jobAddCostCenterSelectedItems = [];

  // End

  // Delete Configuration
  resDeleteSubAreaSelectedItems = [];
  resDeleteHRDeptSelectedItems = [];
  resDeleteCostCenterSelectedItems = [];
  resDeleteManageCountrySelectedItems = [];
  resDeleteEcLocationSelectedItems = [];
  resDeleteCompanyCodeSelectedItems = [];
  resDeleteServiceLineSelectedItems = [];
  resDeleteSubServiceLineSelectedItems = [];
  resDeleteEngCompetencySelectedItems = [];
  resDeleteRankSelectedItems = [];

  jobDeleteSubAreaSelectedItems = [];
  jobDeleteManageCountrySelectedItems = [];
  jobDeleteBusinessUnitSelectedItems = [];
  jobDeleteLegalEntitySelectedItems = [];
  jobDeleteCompanyCodeSelectedItems = [];
  jobDeleteEcLocationsSelectedItems = [];
  jobDeleteEngCompetencySelectedItems = [];
  jobDeleteServiceLineSelectedItems = [];
  jobDeleteSubServiceLineSelectedItems = [];
  jobDeleteSubManagementUnitSelectedItems = [];
  jobDeleteRankSelectedItems = [];
  jobDeleteJobCategorySelectedItems = [];
  jobDeleteJobStatusSelectedItems = [];
  jobDeleteJobStatusBookingSelectedItems = [];
  jobDeleteJobCodeSelectedItems = [];
  jobDeleteIncludeJobCodeSelectedItems = [];
  jobDeleteCostCenterSelectedItems = [];

  // End

  // Replace Configuration
  resReplaceSubAreaSelectedItems = [];
  resReplaceManageCountrySelectedItems = [];
  resReplaceEcLocationSelectedItems = [];
  resReplaceCompanyCodeSelectedItems = [];
  resReplaceServiceLineSelectedItems = [];
  resReplaceSubServiceLineSelectedItems = [];
  resReplaceEngCompetencySelectedItems = [];
  resReplaceHRDeptSelectedItems = [];
  resReplaceCostCenterSelectedItems = [];
  resReplaceRankSelectedItems = [];

  jobReplaceSubAreaSelectedItems = [];
  jobReplaceManageCountrySelectedItems = [];
  jobReplaceBusinessUnitSelectedItems = [];
  jobReplaceLegalEntitySelectedItems = [];
  jobReplaceCompanyCodeSelectedItems = [];
  jobReplaceEcoLocationSelectedItems = [];
  jobReplaceEngCompetencySelectedItems = [];
  jobReplaceServiceLineSelectedItems = [];
  jobReplaceSubServiceLineSelectedItems = [];
  jobReplaceSubManagementUnitSelectedItems = [];
  jobReplaceRankSelectedItems = [];
  jobReplaceJobCategorySelectedItems = [];
  jobReplaceJobStatusSelectedItems = [];
  jobReplaceJobStatusBookingSelectedItems = [];
  jobReplaceJobCodeSelectedItems = [];
  jobReplaceCostCenterSelectedItems = [];
  jobReplaceIncludeJobCodeSelectedItems = [];

  // End

  // Replace Configuration
  resReplaceAllSubAreaSelectedItems = [];
  resReplaceAllManageCountrySelectedItems = [];
  resReplaceAllEcLocationSelectedItems = [];
  resReplaceAllCompanyCodeSelectedItems = [];
  resReplaceAllServiceLineSelectedItems = [];
  resReplaceAllSubServiceLineSelectedItems = [];
  resReplaceAllEngCompetencySelectedItems = [];
  resReplaceAllHRDeptSelectedItems = [];
  resReplaceAllCostCenterSelectedItems = [];
  resReplaceAllRankSelectedItems = [];

  jobReplaceAllSubAreaSelectedItems = [];
  jobReplaceAllManageCountrySelectedItems = [];
  jobReplaceAllBusinessUnitSelectedItems = [];
  jobReplaceAllLegalEntitySelectedItems = [];
  jobReplaceAllCompanyCodeSelectedItems = [];
  jobReplaceAllEcoLocationSelectedItems = [];
  jobReplaceAllEngCompetencySelectedItems = [];
  jobReplaceAllServiceLineSelectedItems = [];
  jobReplaceAllSubServiceLineSelectedItems = [];
  jobReplaceAllSubManagementUnitSelectedItems = [];
  jobReplaceAllRankSelectedItems = [];
  jobReplaceAllJobCategorySelectedItems = [];
  jobReplaceAllJobStatusSelectedItems = [];
  jobReplaceAllJobStatusBookingSelectedItems = [];
  jobReplaceAllJobCodeSelectedItems = [];
  jobReplaceAllIncludeJobCodeSelectedItems = [];
  jobReplaceAllCostCenterSelectedItems = [];

  // End
  resEditSubAreaSelectedItems = [];
  resEditManageCountrySelectedItems = [];
  resEditEcLocationSelectedItems = [];
  resEditCompanyCodeSelectedItems = [];
  resEditServiceLineSelectedItems = [];
  resEditSubServiceLineSelectedItems = [];
  resEditEngCompetencySelectedItems = [];
  resEditHRDeptSelectedItems = [];
  resEditCostCenterSelectedItems = [];
  resEditRankSelectedItems = [];

  jobEditSubAreaSelectedItems = [];
  jobEditManageCountrySelectedItems = [];
  jobEditBusinessUnitSelectedItems = [];
  jobEditLegalEntitySelectedItems = [];
  jobEditServiceLineSelectedItems = [];
  jobEditSubServiceLineSelectedItems = [];
  jobEditSubManagementUnitSelectedItems = [];
  jobEditRankSelectedItems = [];
  jobEditJobCategorySelectedItems = [];
  jobEditJobStatusSelectedItems = [];
  jobEditJobStatusBookingSelectedItems = [];
  jobEditJobCodeSelectedItems = [];
  jobEditIncludeJobCodeSelectedItems = [];
  jobEditCostCenterSelectedItems = [];
  jobEditCompanyCodesSelectedItems = [];
  jobEditEconomicLocationSelectedItems = [];
  jobEditEngagementCompetencySelectedItems = [];

  resViewSubAreaSelectedItems = [];
  resViewManageCountrySelectedItems = [];
  resViewEcLocationSelectedItems = [];
  resViewCompanyCodeSelectedItems = [];
  resViewServiceLineSelectedItems = [];
  resViewSubServiceLineSelectedItems = [];
  resViewEngCompetencySelectedItems = [];
  resViewHRDeptSelectedItems = [];
  resViewCostCenterSelectedItems = [];
  resViewRankSelectedItems = [];

  jobViewSubAreaSelectedItems = [];
  jobViewManageCountrySelectedItems = [];
  jobViewBusinessUnitSelectedItems = [];
  jobViewEconomicLocationsSelectedItems = [];
  jobViewLegalEntitySelectedItems = [];
  jobViewCompanyCodeSelectedItems = [];
  jobViewServiceLineSelectedItems = [];
  jobViewSubServiceLineSelectedItems = [];
  jobViewSubManagementUnitSelectedItems = [];
  jobViewCompetenciesSelectedItems = [];
  jobViewRankSelectedItems = [];
  jobViewJobCategorySelectedItems = [];
  jobViewJobStatusSelectedItems = [];
  jobViewJobStatusBookingSelectedItems = [];
  jobViewJobCodeSelectedItems = [];
  jobViewIncludeJobCodeSelectedItems = [];
  jobViewCostCenterSelectedItems = [];
  actionDescriptionList = [];

  // Feature related variables
  //featureField: {}; //ngModel for features level config
  featuresList = [];
  //featureLevelDtos: FeatureLevelConfigVM[];
  featureDataList: any;
  featuresfilterList: any;
  selectedComponent: boolean = false;
  selectedExpandWallchart : boolean = false;
  selectedExperienceManager: boolean = false;
  selectedJobAssignment: boolean = false;

  priorities = [];
  roleTypes = [];
  selectedItems = [];
  dropdownSettings: IDropdownSettings = {};
  role: RoleVM;
  accessRoleName = '';
  selectedRoleType: any = '';
  selectedPriority: number = 0;
  selectedDelegate: boolean = true;
  remark = '';
  selectedRoleView: boolean = true;
  selectedRoleIsActive: boolean = true;
  assignmentLink: boolean = false;
  assignmentIsActive: boolean = true;
  overallocation: number = 150;
  unconfirmed: boolean;
  isApproverReq: boolean;
  retainInstance: any;
  isAllretainInstReq: boolean;
  instances: any;
  selectedInstance: number;
  roleIndividualView: boolean = true;
  roleEngagementView: boolean = true;
  roleTeamView: boolean = true;
  resourceDetails: any;
  previewSubmit: boolean;
  InstanceEnableAddBookingIV: boolean = true;
  selectedHomeBasedInstance: any = null;

  // Add configuration
  resAddLink: boolean = false;
  resAddIsActive: boolean = false;
  resAddIsDisabled: boolean = false;
  resAddIndividualView: boolean = false;
  resAddEngagementView: boolean = false;
  resAddIsLikeEdit: boolean = false;
  jobAddLink: boolean = false;
  jobAddIsTR: boolean = true;
  jobAddIsDisabled: boolean = false;

  jobAddIsPended: boolean = false;
  jobAddIndividualView: boolean = false;
  jobAddEngagementView: boolean = false;
  jobAddIsLikeEdit: boolean = false;
  // End
  // Delete configuration
  resDeleteLink: boolean = false;
  resDeleteIsActive: boolean = false;
  resDeleteIsDisabled: boolean = false;
  resDeleteIndividualView: boolean = false;
  resDeleteEngagementView: boolean = false;
  resDeleteIsLikeEdit: boolean = false;
  jobDeleteLink: boolean = false;
  jobDeleteIsTR: boolean = true;
  jobDeleteIsDisabled: boolean = false;

  jobDeleteIsPended: boolean = false;
  jobDeleteIndividualView: boolean = false;
  jobDeleteEngagementView: boolean = false;
  jobDeleteIsLikeEdit: boolean = false;
  // End

  // Replace configuration
  resReplaceLink: boolean = false;
  resReplaceIsActive: boolean = false;
  resReplaceIsDisabled: boolean = false;
  resReplaceIndividualView: boolean = false;
  resReplaceEngagementView: boolean = false;
  resReplaceIsLikeEdit: boolean = false;
  jobReplaceLink: boolean = false;
  jobReplaceIsTR: boolean = true;
  jobReplaceIsDisabled: boolean = false;

  jobReplaceIsPended: boolean = false;
  jobReplaceIndividualView: boolean = false;
  jobReplaceEngagementView: boolean = false;
  jobReplaceIsLikeEdit: boolean = false;
  // End

  // Replace All configuration
  resReplaceAllLink: boolean = false;
  resReplaceAllIsActive: boolean = false;
  resReplaceAllIsDisabled: boolean = false;
  resReplaceAllIndividualView: boolean = false;
  resReplaceAllEngagementView: boolean = false;
  resReplaceAllIsLikeEdit: boolean = false;
  jobReplaceAllLink: boolean = false;
  jobReplaceAllIsTR: boolean = true;
  jobReplaceAllIsDisabled: boolean = false;

  jobReplaceAllIsPended: boolean = false;
  jobReplaceAllIndividualView: boolean = false;
  jobReplaceAllEngagementView: boolean = false;
  jobReplaceAllIsLikeEdit: boolean = false;
  // End
  resEditLink: boolean = false;
  resEditIsActive: boolean = false;
  resEditIsDisabled: boolean = false;
  resEditIndividualView: boolean = false;
  resEditEngagementView: boolean = false;
  jobEditLink: boolean = false;
  jobEditIsTR: boolean = true;
  jobEditIsDisabled: boolean = false;
  jobEditIsPended: boolean = false;
  jobEditIndividualView: boolean = false;
  jobEditEngagementView: boolean = false;

  resViewLink: boolean = false;
  resViewIsActive: boolean = false;
  jobViewLink: boolean = false;
  jobViewIsTR: boolean = false;
  jobViewIsPended: boolean = false;

  bookingCurrentWeekEdit: boolean = false;
  bookingCurrentWeekDelete: boolean = false;
  bookingCurrentWeekAdd: boolean = false;
  bookingCurrentWeekCopy: boolean = false;
  bookingCurrentWeekReplace: boolean = false;
  bookingCurrentWeekReplaceAll: boolean = false;
  bookigTrainingEngagementDelete: boolean = true;
  bookigTrainingEngagementEdit: boolean = true;
  bookigDisabledDelete: boolean = false;
  bookigDisabledEdit: boolean = false;
  bookigDisabledCopy: boolean = false;
  bookigDisabledReplace: boolean = false;
  bookigDisabledReplaceAll: boolean = false;
  bookingDisabledGhostView: boolean = true;
  bookingDisabledGhostEdit: boolean = true;
  bookingDisabledGhostDelete: boolean = true;
  bookingDisabledGhostCopy: boolean = true;
  bookingDisabledGhostReplace: boolean = true;
  featureDisableApprovalQ: boolean = false;
  buttonText = 'Submit';
  isExistsAccessRole: boolean = false;
  isHomeRetainNotSelected: boolean = false;
  errorMessage: string = '';
  selectedCoworkers: boolean = false;
  disableActionsGhostBooking: boolean = false;
  SaveErrorMessage: string = '';
  dpDisabled: boolean = true;
  roleTypeEnum = RoleTypeEnum;
  prtDisabled: boolean = false;
  dirtyFlag: boolean = false;
  confirmationClickAction: string = 'cancel';
  customResultId: number;

  //#endregion

  // #region Cntr
  constructor(
    public restService: RoleConfigService,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private sharedService: SharedServicesService,
    private appMemService: AppMemoryService,
    private masterDataService: MasterDataService
  ) {
    this.priorities = new Array(999).fill(0).map((x, i) => i + 1);
  }
  //#endregion

  // #region Init
  ngOnInit() {
     this.spinner.show();
    this.selectedRoleType = 1; //default csp roletype selected
    this.setFormControl();
    // const hasCompleted = this.appMemService.getApiStatus(
    //   DATA_KEY.ROLE_MASTER_DATA
    // );
    // if (!hasCompleted) {
    //   this.spinner.show();
    //   this.appMemService.apiStatus.subscribe((apiStatusData: boolean) => {
    //     if (apiStatusData && apiStatusData == true) {
    //       this.masterData().then(() => {
    //         this.spinner.hide();
    //       });
    //     }
    //   });
    // } else {
    this.masterData().then(() => {
      this.spinner.hide();
    });
    // }

    // this.sleep(5000).then(() => {
    //   this.spinner.hide();
    // });
    //#endregion

    // #region DropdownSeting
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: 'Text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: true,
      enableCheckAll: false,
    };
  }
  //#endregion

  //#region User Defined Methods
  setFormControl() {
    this.formGroup = new FormGroup({
      RoleType: new FormControl('', [Validators.required]),
      Priority: new FormControl(''),
      AccessRoleName: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[^\s][ A-Za-z0-9-,_]*$/),
        Validators.maxLength(200),
      ]),
    });
  }

  clearControls() {
    this.clearMainControlls();
    this.SaveErrorMessage = '';
    // window.scroll(0, 0);
    this.onScroll.emit();
  }

  clearMainControlls() {
    this.accessRoleName = '';
    this.selectedRoleType = '';
    this.assignmentSubAreaSelectedItems = [];
    this.assignmentManageCountrySelectedItems = [];
    this.assignmentBusinessUnitSelectedItems = [];
    this.assignmentEconomicLocationSelectedItems = [];
    this.assignmentOperatingUnitSelectedItems = [];
    this.assignmentManagementUnitSelectedItems = [];
    this.assignmentDepartmentSelectedItems = [];
    this.assignmentLegalEntitySelectedItems = [];
    this.assignmentCompanyCodeSelectedItems = [];
    this.assignmentServiceLineSelectedItems = [];
    this.assignmentSubServiceLineSelectedItems = [];
    this.assignmentSubManagementUnitSelectedItems = [];
    this.assignmentLevelSelectedItems = [];
    this.assignmentEngagementCompetencySelectedItems = [];
    this.assignmentRankSelectedItems = [];

    this.resAddSubAreaSelectedItems = [];
    this.resAddManageCountrySelectedItems = [];
    this.resAddEcLocationSelectedItems = [];
    this.resAddCompanyCodeSelectedItems = [];
    this.resAddServiceLineSelectedItems = [];
    this.resAddSubServiceLineSelectedItems = [];
    this.resAddEngCompetencySelectedItems = [];

    this.resAddHRDeptSelectedItems = [];
    this.resAddCostCenterSelectedItems = [];
    this.resAddRankSelectedItems = [];

    this.jobAddSubAreaSelectedItems = [];
    this.jobAddManageCountrySelectedItems = [];
    this.jobAddBusinessUnitSelectedItems = [];
    this.jobAddLegalEntitySelectedItems = [];

    this.jobAddCompanyCodeSelectedItems = [];
    this.jobAddEconomicLocationsSelectedItems = [];
    this.jobAddEngCompetencySelectedItems = [];
    this.jobAddServiceLineSelectedItems = [];
    this.jobAddSubServiceLineSelectedItems = [];
    this.jobAddSubManagementUnitSelectedItems = [];
    this.jobAddRankSelectedItems = [];
    this.jobAddJobCategorySelectedItems = [];
    this.jobAddJobStatusSelectedItems = [];
    this.jobAddJobStatusBookingSelectedItems = [];
    this.jobAddJobCodeSelectedItems = [];
    this.jobAddIncludeJobCodeSelectedItems = [];
    this.jobAddCostCenterSelectedItems = [];

    // Delete Configuration
    this.resDeleteSubAreaSelectedItems = [];
    this.resDeleteHRDeptSelectedItems = [];
    this.resDeleteCostCenterSelectedItems = [];
    this.resDeleteManageCountrySelectedItems = [];
    this.resDeleteEcLocationSelectedItems = [];
    this.resDeleteCompanyCodeSelectedItems = [];
    this.resDeleteServiceLineSelectedItems = [];
    this.resDeleteSubServiceLineSelectedItems = [];
    this.resDeleteEngCompetencySelectedItems = [];
    this.resDeleteRankSelectedItems = [];

    this.jobDeleteSubAreaSelectedItems = [];
    this.jobDeleteCostCenterSelectedItems = [];
    this.jobDeleteManageCountrySelectedItems = [];
    this.jobDeleteBusinessUnitSelectedItems = [];
    this.jobDeleteLegalEntitySelectedItems = [];
    this.jobDeleteCompanyCodeSelectedItems = [];
    this.jobDeleteEcLocationsSelectedItems = [];
    this.jobDeleteEngCompetencySelectedItems = [];
    this.jobDeleteServiceLineSelectedItems = [];
    this.jobDeleteSubServiceLineSelectedItems = [];
    this.jobDeleteSubManagementUnitSelectedItems = [];
    this.jobDeleteRankSelectedItems = [];
    this.jobDeleteJobCategorySelectedItems = [];
    this.jobDeleteJobStatusSelectedItems = [];
    this.jobDeleteJobStatusBookingSelectedItems = [];
    this.jobDeleteJobCodeSelectedItems = [];
    this.jobDeleteIncludeJobCodeSelectedItems = [];

    // End

    // Replace Configuration
    this.resReplaceSubAreaSelectedItems = [];
    this.resReplaceManageCountrySelectedItems = [];
    this.resReplaceEcLocationSelectedItems = [];
    this.resReplaceCompanyCodeSelectedItems = [];
    this.resReplaceServiceLineSelectedItems = [];
    this.resReplaceSubServiceLineSelectedItems = [];
    this.resReplaceEngCompetencySelectedItems = [];
    this.resReplaceHRDeptSelectedItems = [];
    this.resReplaceCostCenterSelectedItems = [];
    this.resReplaceRankSelectedItems = [];

    this.jobReplaceSubAreaSelectedItems = [];
    this.jobReplaceManageCountrySelectedItems = [];
    this.jobReplaceBusinessUnitSelectedItems = [];
    this.jobReplaceLegalEntitySelectedItems = [];
    this.jobReplaceCompanyCodeSelectedItems = [];
    this.jobReplaceEcoLocationSelectedItems = [];
    this.jobReplaceEngCompetencySelectedItems = [];
    this.jobReplaceServiceLineSelectedItems = [];
    this.jobReplaceSubServiceLineSelectedItems = [];
    this.jobReplaceSubManagementUnitSelectedItems = [];
    this.jobReplaceRankSelectedItems = [];
    this.jobReplaceJobCategorySelectedItems = [];
    this.jobReplaceJobStatusSelectedItems = [];
    this.jobReplaceJobStatusBookingSelectedItems = [];
    this.jobReplaceJobCodeSelectedItems = [];
    this.jobReplaceCostCenterSelectedItems = [];
    this.jobReplaceIncludeJobCodeSelectedItems = [];

    // End
     // Report Config V1
  this.assignmentManageReportList = [];
  this.assignmentManageReportSelectedItems = [];

    // Replace Configuration
    this.resReplaceAllSubAreaSelectedItems = [];
    this.resReplaceAllManageCountrySelectedItems = [];
    this.resReplaceAllEcLocationSelectedItems = [];
    this.resReplaceAllCompanyCodeSelectedItems = [];
    this.resReplaceAllServiceLineSelectedItems = [];
    this.resReplaceAllSubServiceLineSelectedItems = [];
    this.resReplaceAllEngCompetencySelectedItems = [];
    this.resReplaceAllHRDeptSelectedItems = [];
    this.resReplaceAllCostCenterSelectedItems = [];
    this.resReplaceAllRankSelectedItems = [];

    this.jobReplaceAllSubAreaSelectedItems = [];
    this.jobReplaceAllManageCountrySelectedItems = [];
    this.jobReplaceAllBusinessUnitSelectedItems = [];
    this.jobReplaceAllLegalEntitySelectedItems = [];
    this.jobReplaceAllCostCenterSelectedItems = [];

    this.jobReplaceAllCompanyCodeSelectedItems = [];
    this.jobReplaceAllEcoLocationSelectedItems = [];
    this.jobReplaceAllEngCompetencySelectedItems = [];
    this.jobReplaceAllServiceLineSelectedItems = [];
    this.jobReplaceAllSubServiceLineSelectedItems = [];
    this.jobReplaceAllSubManagementUnitSelectedItems = [];
    this.jobReplaceAllRankSelectedItems = [];
    this.jobReplaceAllJobCategorySelectedItems = [];
    this.jobReplaceAllJobStatusSelectedItems = [];
    this.jobReplaceAllJobStatusBookingSelectedItems = [];
    this.jobReplaceAllJobCodeSelectedItems = [];
    this.jobReplaceAllIncludeJobCodeSelectedItems = [];

    // End
    this.resEditSubAreaSelectedItems = [];
    this.resEditManageCountrySelectedItems = [];
    this.resEditEcLocationSelectedItems = [];
    this.resEditCompanyCodeSelectedItems = [];
    this.resEditServiceLineSelectedItems = [];
    this.resEditSubServiceLineSelectedItems = [];
    this.resEditEngCompetencySelectedItems = [];
    this.resEditHRDeptSelectedItems = [];
    this.resEditCostCenterSelectedItems = [];
    this.resEditRankSelectedItems = [];

    this.jobEditSubAreaSelectedItems = [];
    this.jobEditManageCountrySelectedItems = [];
    this.jobEditBusinessUnitSelectedItems = [];
    this.jobEditLegalEntitySelectedItems = [];
    this.jobEditServiceLineSelectedItems = [];
    this.jobEditSubServiceLineSelectedItems = [];
    this.jobEditSubManagementUnitSelectedItems = [];
    this.jobEditRankSelectedItems = [];
    this.jobEditJobCategorySelectedItems = [];
    this.jobEditJobStatusSelectedItems = [];
    this.jobEditJobStatusBookingSelectedItems = [];
    this.jobEditJobCodeSelectedItems = [];
    this.jobEditIncludeJobCodeSelectedItems = [];
    this.jobEditCostCenterSelectedItems = [];
    this.jobEditCompanyCodesSelectedItems = [];
    this.jobEditEconomicLocationSelectedItems = [];
    this.jobEditEngagementCompetencySelectedItems = [];

    this.resViewSubAreaSelectedItems = [];
    this.resViewManageCountrySelectedItems = [];
    this.resViewEcLocationSelectedItems = [];
    this.resViewCompanyCodeSelectedItems = [];
    this.resViewServiceLineSelectedItems = [];
    this.resViewSubServiceLineSelectedItems = [];
    this.resViewEngCompetencySelectedItems = [];
    this.resViewHRDeptSelectedItems = [];
    this.resViewCostCenterSelectedItems = [];
    this.resViewRankSelectedItems = [];

    this.jobViewSubAreaSelectedItems = [];
    this.jobViewManageCountrySelectedItems = [];
    this.jobViewBusinessUnitSelectedItems = [];
    this.jobViewEconomicLocationsSelectedItems = [];
    this.jobViewLegalEntitySelectedItems = [];
    this.jobViewCompanyCodeSelectedItems = [];
    this.jobViewServiceLineSelectedItems = [];
    this.jobViewSubServiceLineSelectedItems = [];
    this.jobViewSubManagementUnitSelectedItems = [];
    this.jobViewCompetenciesSelectedItems = [];
    this.jobViewRankSelectedItems = [];
    this.jobViewJobCategorySelectedItems = [];
    this.jobViewJobStatusSelectedItems = [];
    this.jobViewJobStatusBookingSelectedItems = [];
    this.jobViewJobCodeSelectedItems = [];
    this.jobViewIncludeJobCodeSelectedItems = [];
    this.jobViewCostCenterSelectedItems = [];
    this.selectedRoleView = true;
    this.selectedRoleIsActive = true;
    this.assignmentLink = false;
    this.assignmentIsActive = true;
    this.resAddLink = false;
    this.resAddIsActive = false;
    this.resAddIsDisabled = false;
    this.resAddIndividualView = false;
    this.resAddEngagementView = false;
    this.resAddIsLikeEdit = false;
    this.jobAddLink = false;
    this.jobAddIsTR = true;
    this.jobAddIsDisabled = false;
    this.jobAddIsPended = false;
    this.jobAddIndividualView = false;
    this.jobAddEngagementView = false;
    this.jobAddIsLikeEdit = false;

    this.resDeleteLink = false;
    this.resDeleteIsActive = false;
    this.resDeleteIsDisabled = false;
    this.resDeleteIndividualView = false;
    this.resDeleteEngagementView = false;
    this.resDeleteIsLikeEdit = false;

    this.jobDeleteLink = false;
    this.jobDeleteIsTR = true;
    this.jobDeleteIsDisabled = false;
    this.jobDeleteIsPended = false;
    this.jobDeleteIndividualView = false;
    this.jobDeleteEngagementView = false;
    this.jobDeleteIsLikeEdit = false;

    this.resReplaceLink = false;
    this.resReplaceIsActive = false;
    this.resReplaceIsDisabled = false;
    this.resReplaceIndividualView = false;
    this.resReplaceEngagementView = false;
    this.resReplaceIsLikeEdit = false;
    this.jobReplaceLink = false;
    this.jobReplaceIsTR = true;
    this.jobReplaceIsDisabled = false;
    this.jobReplaceIsPended = false;
    this.jobReplaceIndividualView = false;
    this.jobReplaceEngagementView = false;
    this.jobReplaceIsLikeEdit = false;

    this.resReplaceAllLink = false;
    this.resReplaceAllIsActive = false;
    this.resReplaceAllIsDisabled = false;
    this.resReplaceAllIndividualView = false;
    this.resReplaceAllEngagementView = false;
    this.resReplaceAllIsLikeEdit = false;
    this.jobReplaceAllLink = false;
    this.jobReplaceAllIsTR = true;
    this.jobReplaceAllIsDisabled = false;
    this.jobReplaceAllIsPended = false;
    this.jobReplaceAllIndividualView = false;
    this.jobReplaceAllEngagementView = false;
    this.jobReplaceAllIsLikeEdit = false;

    this.resEditLink = false;
    this.resEditIsActive = false;
    this.resEditIsDisabled = false;
    this.resEditIndividualView = false;
    this.resEditEngagementView = false;
    this.jobEditLink = false;
    this.jobEditIsTR = true;
    this.jobEditIsDisabled = false;
    this.jobEditIsPended = false;
    this.jobEditIndividualView = false;
    this.jobEditEngagementView = false;

    this.resViewLink = false;
    this.resViewIsActive = false;
    this.jobViewLink = false;
    this.jobViewIsTR = false;
    this.jobViewIsPended = false;

    this.bookingCurrentWeekEdit = false;
    this.bookingCurrentWeekDelete = false;
    this.bookingCurrentWeekAdd = false;
    this.bookingCurrentWeekCopy = false;
    this.bookingCurrentWeekReplace = false;
    this.bookingCurrentWeekReplaceAll = false;
    this.bookigTrainingEngagementDelete = true;
    this.bookigTrainingEngagementEdit = true;
    this.bookigDisabledDelete = false;
    this.bookigDisabledEdit = false;
    this.bookigDisabledCopy = false;
    this.bookigDisabledReplace = false;
    this.bookigDisabledReplaceAll = false;
    // initializing the 5 ghost booking action checkboxes
    this.resetGhostBookingActionCheckBoxes();
    this.selectedDelegate = true;
    this.buttonText = 'Submit';
    this.isExistsAccessRole = false;
    this.errorMessage = '';
    this.selectedCoworkers = false;
    this.selectedComponent = false;
    this.selectedExpandWallchart = false;
    this.selectedExperienceManager = false;
    this.selectedJobAssignment = false;
    this.remark = '';
    this.selectedPriority = 0;
    this.onChangeRoleType();
    this.confirmationClickAction = 'cancel';
    this.customResultId = null;
    this.dirtyFlag = false;
  }

  populateRoleApprovalDTO(data) {
    this.makeDirty();
    this.approvalArrDtoForSubmission = data;
  }

  makeDirty() {
    if (!this.dirtyFlag) {
      this.dirtyFlag = true;
    }
  }

  managePrioirtyDisable() {
    let csRole = this.roleTypes.find((x) => x.ID == this.selectedRoleType);
    if (csRole != null && csRole.Code == this.roleTypeEnum.ClientServer) {
      this.selectedPriority = 1;
      this.prtDisabled = false;
    } else if (
      csRole != null &&
      csRole.Code == this.roleTypeEnum.ResourceAdmin
    ) {
      this.selectedPriority = 0;
      this.prtDisabled = true;
      this.isApproverReq = false;
    } else {
      this.selectedPriority = 0;
      this.prtDisabled = false;
    }
  }

  onChangeFeatureFieldModel(): void {
    //alert(JSON.stringify(this.featuresList));
    this.makeDirty();
    // const excludedFeatures: any = Object.keys(this.featureField).filter(
    //   (item) => this.featureField[item] === true
    // );

    // this.featureLevelDtos = excludedFeatures.map((item) => {
    //   return {
    //     IsExclude: true,
    //     RFC_F_ID: this.featuresList.find((it) => it.Text === item).Id,
    //   };
    // });
  }

  onChangeMultiInsta(): void {
    this.makeDirty();
    this.roleIndividualView = true;
    this.roleEngagementView = true;
    this.roleTeamView = true;
    this.InstanceEnableAddBookingIV = true;
    this.selectedHomeBasedInstance = null;
    this.isHomeRetainNotSelected = false;
  }

  onChangeNewBookingIV(): void {
    this.makeDirty();
    this.selectedHomeBasedInstance = null;
    this.isHomeRetainNotSelected = false;
  }

  setControlsData = (data) => {
    if (data?.ActionDescriptionList != null) {
      const dummyArray = this.masterDataService.getDummyArray(
        data.ActionDescriptionList
      );
      this.actionDescriptionList = [...dummyArray];
      this.actionDescriptionList = this.actionDescriptionList.filter(
        (item) => item.Id != 6 && item.Id != 3
      );
    }
    if (data.FeatureList != null) {
      this.featureDataList = data.FeatureList;
      this.manageFeatureLevelConfiguration();
    }
    this.masterDataService.setControlsData(data);
  };

  onAccordionOpen = (event, type) => {
    event.preventDefault();
    if (this.panelOpenState) {
      if (
        (type == ROLE_LAYERS.VIEW_CONFIG && !this.resViewSubAreaList.length) ||
        (type == ROLE_LAYERS.EDIT_CONFIG && !this.resEditSubAreaList.length) ||
        (type == ROLE_LAYERS.ADD_CONFIG && !this.resAddSubAreaList.length) ||
        (type == ROLE_LAYERS.DELETE_CONFIG &&
          !this.resDeleteSubAreaList.length) ||
        (type == ROLE_LAYERS.REPLACE_CONFIG &&
          !this.resReplaceSubAreaList.length) ||
        (type == ROLE_LAYERS.REPLACE_ALL_CONFIG &&
          !this.resReplaceAllSubAreaList.length) ||
        (type == ROLE_LAYERS.ASSIGNMENT_CONFIG &&
          !this.assignmentSubAreaList.length)
      ) {
        this.spinner.show();
      }

      this.sleep(500).then(() => {
        switch (type) {
          case ROLE_LAYERS.VIEW_CONFIG:
            if (!this.resViewSubAreaList.length) {
              this.resViewSubAreaList = [...this.masterDataService.dataSubArea];
              this.resViewManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.resViewCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.resViewEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.resViewServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.resViewSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.resViewEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.resViewHRDeptList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.resViewCostCenterList = [
                ...this.masterDataService.dataResCostCenter,
              ];
              this.jobViewSubAreaList = [...this.masterDataService.dataSubArea];
              this.jobViewManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.jobViewLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.jobViewBusinessUnitList = [
                ...this.masterDataService.dataBusinessUnit,
              ];
              this.jobViewServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.jobViewSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.jobViewSubManagementUnitList = [
                ...this.masterDataService.dataSubManagementUnit,
              ];
              this.jobViewJobCategoryList = [
                ...this.masterDataService.dataJobCategory,
              ];
              this.jobViewJobStatusList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobViewJobStatusBookingList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobViewJobCodeList = [...this.masterDataService.dataJobCode];
              this.jobViewIncludeJobCodeList = [
                ...this.masterDataService.dataIncludeJobCode,
              ];
              this.jobViewCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.jobViewEconomicLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.jobViewEngagementCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.jobViewCostCenterList = [
                ...this.masterDataService.dataJobCostCenter,
              ];
            }
            break;

          case ROLE_LAYERS.EDIT_CONFIG:
            if (!this.resEditSubAreaList.length) {
              this.resEditSubAreaList = [...this.masterDataService.dataSubArea];
              this.resEditManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.resEditCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.resEditEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.resEditServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.resEditSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.resEditEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.resEditHRDeptList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.resEditCostCenterList = [
                ...this.masterDataService.dataResCostCenter,
              ];
              this.jobEditSubAreaList = [...this.masterDataService.dataSubArea];
              this.jobEditManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.jobEditLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.jobEditBusinessUnitList = [
                ...this.masterDataService.dataBusinessUnit,
              ];
              this.jobEditServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.jobEditSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.jobEditSubManagementUnitList = [
                ...this.masterDataService.dataSubManagementUnit,
              ];
              this.jobEditJobCategoryList = [
                ...this.masterDataService.dataJobCategory,
              ];
              this.jobEditJobStatusList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobEditJobStatusBookingList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobEditJobCodeList = [...this.masterDataService.dataJobCode];
              this.jobEditIncludeJobCodeList = [
                ...this.masterDataService.dataIncludeJobCode,
              ];
              this.jobEditCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.jobEditEconomicLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.jobEditEngagementCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.jobEditCostCenterList = [
                ...this.masterDataService.dataJobCostCenter,
              ];
            }
            break;

          case ROLE_LAYERS.ADD_CONFIG:
            if (!this.resAddSubAreaList.length) {
              this.resAddSubAreaList = [...this.masterDataService.dataSubArea];
              this.resAddManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.resAddCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.resAddEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.resAddServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.resAddSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.resAddEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.resAddHRDeptList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.resAddCostCenterList = [
                ...this.masterDataService.dataResCostCenter,
              ];
              this.jobAddSubAreaList = [...this.masterDataService.dataSubArea];
              this.jobAddManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.jobAddLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.jobAddBusinessUnitList = [
                ...this.masterDataService.dataBusinessUnit,
              ];
              this.jobAddServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.jobAddSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.jobAddSubManagementUnitList = [
                ...this.masterDataService.dataSubManagementUnit,
              ];
              this.jobAddJobCategoryList = [
                ...this.masterDataService.dataJobCategory,
              ];
              this.jobAddJobStatusList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobAddJobStatusBookingList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobAddJobCodeList = [...this.masterDataService.dataJobCode];
              this.jobAddIncludeJobCodeList = [
                ...this.masterDataService.dataIncludeJobCode,
              ];
              this.jobAddCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.jobAddEconomicLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.jobAddEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.jobAddCostCenterList = [
                ...this.masterDataService.dataJobCostCenter,
              ];
            }
            break;

          case ROLE_LAYERS.DELETE_CONFIG:
            if (!this.resDeleteSubAreaList.length) {
              this.resDeleteSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.resDeleteManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.resDeleteCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.resDeleteEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.resDeleteServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.resDeleteSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.resDeleteEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.resDeleteHRDeptList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.resDeleteCostCenterList = [
                ...this.masterDataService.dataResCostCenter,
              ];
              this.jobDeleteSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.jobDeleteManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.jobDeleteLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.jobDeleteBusinessUnitList = [
                ...this.masterDataService.dataBusinessUnit,
              ];
              this.jobDeleteServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.jobDeleteSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.jobDeleteSubManagementUnitList = [
                ...this.masterDataService.dataSubManagementUnit,
              ];
              this.jobDeleteJobCategoryList = [
                ...this.masterDataService.dataJobCategory,
              ];
              this.jobDeleteJobStatusList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobDeleteJobStatusBookingList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobDeleteJobCodeList = [
                ...this.masterDataService.dataJobCode,
              ];
              this.jobDeleteIncludeJobCodeList = [
                ...this.masterDataService.dataIncludeJobCode,
              ];
              this.jobDeleteCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.jobDeleteEcoLocationsList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.jobDeleteEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.jobDeleteCostCenterList = [
                ...this.masterDataService.dataJobCostCenter,
              ];
            }
            break;

          case ROLE_LAYERS.REPLACE_CONFIG:
            if (!this.resReplaceSubAreaList.length) {
              this.resReplaceSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.resReplaceManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.resReplaceCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.resReplaceEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.resReplaceServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.resReplaceSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.resReplaceEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.resReplaceHRDeptList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.resReplaceCostCenterList = [
                ...this.masterDataService.dataResCostCenter,
              ];
              this.jobReplaceSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.jobReplaceManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.jobReplaceLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.jobReplaceBusinessUnitList = [
                ...this.masterDataService.dataBusinessUnit,
              ];
              this.jobReplaceServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.jobReplaceSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.jobReplaceSubManagementUnitList = [
                ...this.masterDataService.dataSubManagementUnit,
              ];
              this.jobReplaceJobCategoryList = [
                ...this.masterDataService.dataJobCategory,
              ];
              this.jobReplaceJobStatusList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobReplaceJobStatusBookingList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobReplaceJobCodeList = [
                ...this.masterDataService.dataJobCode,
              ];
              this.jobReplaceIncludeJobCodeList = [
                ...this.masterDataService.dataIncludeJobCode,
              ];
              this.jobReplaceCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.jobReplaceEcoLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.jobReplaceEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.jobReplaceCostCenterList = [
                ...this.masterDataService.dataJobCostCenter,
              ];
            }
            break;

          case ROLE_LAYERS.REPLACE_ALL_CONFIG:
            if (!this.resReplaceAllSubAreaList.length) {
              this.resReplaceAllSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.resReplaceAllManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.resReplaceAllCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.resReplaceAllEcLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.resReplaceAllServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.resReplaceAllSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.resReplaceAllEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.resReplaceAllHRDeptList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.resReplaceAllCostCenterList = [
                ...this.masterDataService.dataResCostCenter,
              ];
              this.jobReplaceAllSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.jobReplaceAllManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.jobReplaceAllLegalEntityList = [
                ...this.masterDataService.dataLegalEntity,
              ];
              this.jobReplaceAllBusinessUnitList = [
                ...this.masterDataService.dataBusinessUnit,
              ];
              this.jobReplaceAllServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.jobReplaceAllSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.jobReplaceAllSubManagementUnitList = [
                ...this.masterDataService.dataSubManagementUnit,
              ];
              this.jobReplaceAllJobCategoryList = [
                ...this.masterDataService.dataJobCategory,
              ];
              this.jobReplaceAllJobStatusList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobReplaceAllJobStatusBookingList = [
                ...this.masterDataService.dataJobStatus,
              ];
              this.jobReplaceAllJobCodeList = [
                ...this.masterDataService.dataJobCode,
              ];
              this.jobReplaceAllIncludeJobCodeList = [
                ...this.masterDataService.dataIncludeJobCode,
              ];
              this.jobReplaceAllCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.jobReplaceAllEcoLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.jobReplaceAllEngCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.jobReplaceAllCostCenterList = [
                ...this.masterDataService.dataJobCostCenter,
              ];
            }
            break;

          case ROLE_LAYERS.ASSIGNMENT_CONFIG:
            if (!this.assignmentSubAreaList.length) {
              this.assignmentSubAreaList = [
                ...this.masterDataService.dataSubArea,
              ];
              this.assignmentManageCountryList = [
                ...this.masterDataService.dataManageCountry,
              ];
              this.assignmentCompanyCodeList = [
                ...this.masterDataService.dataCompanyCode,
              ];
              this.assignmentEconomicLocationList = [
                ...this.masterDataService.dataEconomicLocation,
              ];
              this.assignmentServiceLineList = [
                ...this.masterDataService.dataServiceLine,
              ];
              this.assignmentSubServiceLineList = [
                ...this.masterDataService.dataSubServiceLine,
              ];
              this.assignmentEngagementCompetencyList = [
                ...this.masterDataService.dataCompetency,
              ];
              this.assignmentDepartmentList = [
                ...this.masterDataService.dataDepartment,
              ];
              this.assignmentLevelList = [
                ...this.masterDataService.dataActivityType,
              ];
            }
            break;

          case ROLE_LAYERS.APPROVAL_LAYER_CONFIG:
            this.jobAddJobCategoryList = [
              ...this.masterDataService.dataJobCategory,
            ];
            break;

            case ROLE_LAYERS.REPORT_CONFIG:
              this.assignmentManageReportList = [
                ...this.masterDataService.dataReport,
              ];
              //console.log(this.assignmentManageReportList);
              break;
        }
      });
      this.sleep(5000).then(() => {
        this.spinner.hide();
      });
    }
  };

  masterData() {
      return new Promise<void>((resolve, reject) => {
      // In order to add caching of masterData using appMemService, uncomment the below lines.

      // const roleMasterData = this.appMemService.getData(
      //   DATA_KEY.ROLE_MASTER_DATA
      // );
      // if (roleMasterData && Object.keys(roleMasterData > 0)) {
      //   this.setControlsData(roleMasterData);
      //   this.roleTypes = roleMasterData.RoleTypeList;
      //   this.onChangeRoleType();
      //   resolve();
      // }

      this.resourceDetails = JSON.parse(sessionStorage.getItem('resource'));
      this.getUserInstances();
      this.restService.getMasterData().subscribe(
        (data) => {
          // this.appMemService.setData(DATA_KEY.ROLE_MASTER_DATA, data); // Cache master data
          this.roleTypes = data.RoleTypeList;
          this.setControlsData(data); // Set values to controls
          this.onChangeRoleType();
          resolve();
        },
        (error) => {
          console.log('Error while fetching the master data', error);
          alert('Error while fetching the master data, please refresh');
          reject();
        },
        () => {
          console.log('Master data fetched');
        }
      );
      // }
    });
  }

  getUserInstances() {
    const userInstance = this.sharedService.getStoredUserInstances();

    if (userInstance === null || userInstance === undefined) {
      this.sharedService.getUserInstances().subscribe((data) => {
        this.instances = this.sharedService.getStoredUserInstances();
        const selected = this.instances?.filter(
          (x) => x.InstanceId === this.resourceDetails.DefaultInstance
        );
        if (selected) {
          this.selectedInstance = selected[0].InstanceId;
        }
      });
    } else {
      this.instances = userInstance;
      const selected = this.instances?.filter(
        (x) => x.InstanceId === this.resourceDetails.DefaultInstance
      );
      if (selected) {
        this.selectedInstance = selected[0].InstanceId;
      }
    }
  }

  onInstanceChange(event) {
    this.selectedInstance = event.value;
  }

  onHomeBasedInstanceChange(event) {
    this.isHomeRetainNotSelected = false;
    this.selectedHomeBasedInstance = event.value;
  }

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  openConfirmationModal(template, confirmationAction) {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.confirmationClickAction = confirmationAction;
    this.modalRef = this.modalService.show(template, this.modalOption);
  }

  //#endregion

  // #region HTML control event
  cancel(template, confirmationAction) {
    this.openConfirmationModal(template, confirmationAction);
  }

  reset(template, confirmationAction) {
    this.openConfirmationModal(template, confirmationAction);
  }

  onConfirmAction() {
    this.modalRef.hide();
    if (this.confirmationClickAction.toLocaleLowerCase() == 'reset') {
      this.clearControls();
    } else {
      this.restService.cancelClick();
    }
  }

  resetEnableGhostBooking() {
    this.makeDirty();
    this.resetGhostBookingActionCheckBoxes();
  }

  resetGhostBookingActionCheckBoxes() {
    this.bookingDisabledGhostView = true;
    this.bookingDisabledGhostEdit = true;
    this.bookingDisabledGhostDelete = true;
    this.bookingDisabledGhostCopy = true;
    this.bookingDisabledGhostReplace = true;
  }

  onSubmit() {
    //debugger;
    if (!this.dirtyFlag || this.formGroup.invalid || this.isExistsAccessRole) {
      // window.scroll(0, 0);
      this.onScroll.emit();
      return;
    }

    if (this.accessRoleName.trim() === '') {
      this.isExistsAccessRole = true;
      this.errorMessage = 'Role Name is required';
      // window.scroll(0, 0);
      this.onScroll.emit();
      return;
    }

    if (
      !this.InstanceEnableAddBookingIV &&
      this.selectedHomeBasedInstance == null
    ) {
      this.isHomeRetainNotSelected = true;
      this.errorMessage = 'Please Select Home-Based Retain Instance';
      // window.scroll(0, 0);
      this.onScroll.emit();
      return;
    }

    this.spinner.show();
    this.buttonText = 'Please wait..';
    this.role = new RoleVM();
    let assingmentDto = new AssignmentConfigurationDto();
    let resAddDto = new ResourceAddConfigurationDto();
    let jobAddDto = new JobAddConfigurationDto();
    let resDeleteDto = new ResourceDeleteConfigurationDto();
    let jobDeleteDto = new JobDeleteConfigurationDto();
    let resReplaceDto = new ResourceReplaceConfigurationDto();
    let jobReplaceDto = new JobReplaceConfigurationDto();
    let resReplaceAllDto = new ResourceReplaceAllConfigurationDto();
    let jobReplaceAllDto = new JobReplaceAllConfigurationDto();
    let resEditDto = new ResourceEditConfigurationDto();
    let jobEditDto = new JobEditConfigurationDto();
    let resViewDto = new ResourceViewConfigurationDto();
    let jobViewDto = new JobViewConfigurationDto();
    let bookingConfigurationDto = new BookingConfigurationDto();

    this.role.R_ID = 0;
    this.role.R_RT_ID = +this.selectedRoleType;
    this.role.R_Name = this.accessRoleName;
    this.role.R_Priority = this.selectedPriority;
    this.role.R_Comments = this.remark;
    this.role.R_View = this.selectedRoleView;
    this.role.R_Delegate = this.selectedDelegate;
    this.role.R_RELinkConfig = this.resEditLink;
    this.role.R_RADLinkConfig = this.resAddLink; // Add Config
    this.role.R_RVLinkConfig = this.resViewLink;
    this.role.R_JELinkConfig = this.jobEditLink;
    this.role.R_JADLinkConfig = this.jobAddLink; // Add Config
    this.role.R_JVLinkConfig = this.jobViewLink;
    this.role.R_RALinkConfig = this.assignmentLink;
    this.role.R_CreatedBy = +sessionStorage.getItem('loggedin_resourceid');
    this.role.R_IsActive = this.selectedRoleIsActive;
    this.role.R_CoWorker = this.selectedCoworkers;
    this.role.R_Enable_JobAssignDescr = this.selectedJobAssignment;
    this.role.R_Enable_CompDescr = this.selectedComponent;
    this.role.R_Expand_Wallchart = this.selectedExpandWallchart;
    //v1
    this.role.R_Experience_Manager = this.selectedExperienceManager;
    this.role.R_Ghost = this.disableActionsGhostBooking;
    this.role.R_MUltipleInstance = this.isAllretainInstReq;
    this.role.R_OverAllocation = this.overallocation;
    this.role.R_Unconfirmed = this.unconfirmed;
    this.role.R_IsReqdApproval = this.isApproverReq;
    this.role.R_I_ID = this.isAllretainInstReq ? null : this.selectedInstance;
    this.role.R_InstEnable_IV = this.roleIndividualView;
    this.role.R_InstEnable_EV = this.roleEngagementView;
    this.role.R_InstEnable_TV = this.roleTeamView;
    this.role.R_PreviewSubmit = this.previewSubmit;
    this.role.R_InstEnable_AddBooking = this.InstanceEnableAddBookingIV;
    this.role.R_Home_InstanceID = this.selectedHomeBasedInstance;

    assingmentDto.AssignmentSubAreas = this.assignmentSubAreaSelectedItems;
    assingmentDto.AssignmentSubManageUnits =
      this.assignmentSubManagementUnitSelectedItems;

    assingmentDto.AssignmentCompetencies =
      this.assignmentEngagementCompetencySelectedItems;
    assingmentDto.AssignmentSubServiceLines =
      this.assignmentSubServiceLineSelectedItems;
    assingmentDto.AssignmentManagerialCountries =
      this.assignmentManageCountrySelectedItems;
    assingmentDto.AssignmentLegalEntities =
      this.assignmentLegalEntitySelectedItems;
    assingmentDto.AssignmentCompanyCodes =
      this.assignmentCompanyCodeSelectedItems;
    assingmentDto.AssignmentServiceLines =
      this.assignmentServiceLineSelectedItems;
    assingmentDto.AssignmentBusinessUnits =
      this.assignmentBusinessUnitSelectedItems;

    assingmentDto.AssignmentEconomicLocations =
      this.assignmentEconomicLocationSelectedItems;
    assingmentDto.AssignmentOperatingUnits =
      this.assignmentOperatingUnitSelectedItems;
    assingmentDto.AssignmentManageUnits =
      this.assignmentManagementUnitSelectedItems;
    assingmentDto.AssignmentDepartment = this.assignmentDepartmentSelectedItems;
    // assingmentDto.AssignmentRanks = this.assignmentRankSelectedItems;
    assingmentDto.ActivityTypes = this.assignmentLevelSelectedItems;
    assingmentDto.RAR_ISACTIVE = this.assignmentIsActive;

    // Start Add Configuration
    resAddDto.ResAddSubAreas = this.resAddSubAreaSelectedItems;
    resAddDto.ResAddCompetencies = this.resAddEngCompetencySelectedItems;
    resAddDto.ResAddDepartments = this.resAddHRDeptSelectedItems;
    resAddDto.ResAddCostCenters = this.resAddCostCenterSelectedItems;
    resAddDto.ResAddSubServiceLines = this.resAddSubServiceLineSelectedItems;
    resAddDto.ResAddManagerialCountries = this.resAddManageCountrySelectedItems;
    resAddDto.ResAddCompanyCodes = this.resAddCompanyCodeSelectedItems;
    resAddDto.ResAddServiceLines = this.resAddServiceLineSelectedItems;
    resAddDto.ResAddEconomicLocations = this.resAddEcLocationSelectedItems;
    resAddDto.RRAC_RInactive = this.resAddIsActive;
    resAddDto.RRAC_ISDisabled = this.resAddIsDisabled;
    resAddDto.RRAC_ISLikeEdit = this.resAddIsLikeEdit;
    resAddDto.RRAC_IV_Disabled = this.resAddIndividualView;
    resAddDto.RRAC_EV_Disabled = this.resAddEngagementView;

    jobAddDto.JobAddSubAreas = this.jobAddSubAreaSelectedItems;
    jobAddDto.JobAddSubManageUnits = this.jobAddSubManagementUnitSelectedItems;
    jobAddDto.JobAddSubServiceLines = this.jobAddSubServiceLineSelectedItems;
    jobAddDto.JobAddManagerialCountries = this.jobAddManageCountrySelectedItems;
    jobAddDto.JobAddLegalEntities = this.jobAddLegalEntitySelectedItems;
    jobAddDto.JobAddCompanyCodes = this.jobAddCompanyCodeSelectedItems;
    jobAddDto.JobAddEconomicLocations =
      this.jobAddEconomicLocationsSelectedItems;
    jobAddDto.JobAddCompetencies = this.jobAddEngCompetencySelectedItems;

    jobAddDto.JobAddServiceLines = this.jobAddServiceLineSelectedItems;
    jobAddDto.JobAddBusinessUnits = this.jobAddBusinessUnitSelectedItems;

    jobAddDto.JobAddJobCategories = this.jobAddJobCategorySelectedItems;
    jobAddDto.JobAddJobCode = this.jobAddJobCodeSelectedItems;
    jobAddDto.JobAddIncludeJobCode = this.jobAddIncludeJobCodeSelectedItems;
    jobAddDto.JobAddCostCenters = this.jobAddCostCenterSelectedItems;
    jobAddDto.JobAddJobStatuses = this.jobAddJobStatusSelectedItems;
    jobAddDto.JobAddJobStatusBookings =
      this.jobAddJobStatusBookingSelectedItems;
    jobAddDto.RJAC_Learning = this.jobAddIsTR;
    jobAddDto.RJAC_ISDisabled = this.jobAddIsDisabled;
    jobAddDto.RJAC_ISLikeEdit = this.jobAddIsLikeEdit;
    jobAddDto.RJAC_IsPended = this.jobAddIsPended;
    jobAddDto.RJAC_IV_Disabled = this.jobAddIndividualView;
    jobAddDto.RJAC_EV_Disabled = this.jobAddEngagementView;
    // END Add Configuration

    // Start Delete  Configuration
    resDeleteDto.ResDeleteSubAreas = this.resDeleteSubAreaSelectedItems;
    resDeleteDto.ResDeleteCompetencies =
      this.resDeleteEngCompetencySelectedItems;
    resDeleteDto.ResDeleteDepartments = this.resDeleteHRDeptSelectedItems;
    resDeleteDto.ResDeleteCostCenters = this.resDeleteCostCenterSelectedItems;
    resDeleteDto.ResDeleteSubServiceLines =
      this.resDeleteSubServiceLineSelectedItems;
    resDeleteDto.ResDeleteManagerialCountries =
      this.resDeleteManageCountrySelectedItems;
    resDeleteDto.ResDeleteCompanyCodes = this.resDeleteCompanyCodeSelectedItems;
    resDeleteDto.ResDeleteServiceLines = this.resDeleteServiceLineSelectedItems;
    resDeleteDto.ResDeleteEconomicLocations =
      this.resDeleteEcLocationSelectedItems;
    resDeleteDto.RRDC_RInactive = this.resDeleteIsActive;
    resDeleteDto.RRDC_ISDisabled = this.resDeleteIsDisabled;
    resDeleteDto.RRDC_ISLikeEdit = this.resDeleteIsLikeEdit;
    resDeleteDto.RRDC_IV_Disabled = this.resDeleteIndividualView;
    resDeleteDto.RRDC_EV_Disabled = this.resDeleteEngagementView;

    jobDeleteDto.JobDeleteSubAreas = this.jobDeleteSubAreaSelectedItems;
    jobDeleteDto.JobDeleteSubManageUnits =
      this.jobDeleteSubManagementUnitSelectedItems;
    jobDeleteDto.JobDeleteSubServiceLines =
      this.jobDeleteSubServiceLineSelectedItems;
    jobDeleteDto.JobDeleteManagerialCountries =
      this.jobDeleteManageCountrySelectedItems;
    jobDeleteDto.JobDeleteCostCenters = this.jobDeleteCostCenterSelectedItems;
    jobDeleteDto.JobDeleteLegalEntities =
      this.jobDeleteLegalEntitySelectedItems;
    jobDeleteDto.JobDeleteCompanyCodes = this.jobDeleteCompanyCodeSelectedItems;
    jobDeleteDto.JobDeleteEconomicLocations =
      this.jobDeleteEcLocationsSelectedItems;
    jobDeleteDto.JobDeleteCompetencies =
      this.jobDeleteEngCompetencySelectedItems;
    jobDeleteDto.JobDeleteServiceLines = this.jobDeleteServiceLineSelectedItems;
    jobDeleteDto.JobDeleteBusinessUnits =
      this.jobDeleteBusinessUnitSelectedItems;
    jobDeleteDto.JobDeleteJobCategories =
      this.jobDeleteJobCategorySelectedItems;
    jobDeleteDto.JobDeleteJobCode = this.jobDeleteJobCodeSelectedItems;
    jobDeleteDto.JobDeleteIncludeJobCode =
      this.jobDeleteIncludeJobCodeSelectedItems;
    jobDeleteDto.JobDeleteJobStatuses = this.jobDeleteJobStatusSelectedItems;
    jobDeleteDto.JobDeleteJobStatusBookings =
      this.jobDeleteJobStatusBookingSelectedItems;
    jobDeleteDto.RJDC_Learning = this.jobDeleteIsTR;
    jobDeleteDto.RJDC_ISDisabled = this.jobDeleteIsDisabled;
    jobDeleteDto.RJDC_ISLikeEdit = this.jobDeleteIsLikeEdit;
    jobDeleteDto.RJDC_IsPended = this.jobDeleteIsPended;
    jobDeleteDto.RJDC_IV_Disabled = this.jobDeleteIndividualView;
    jobDeleteDto.RJDC_EV_Disabled = this.jobDeleteEngagementView;
    // END Delete Configuration

    // Start Replace  Configuration
    resReplaceDto.ResReplaceSubAreas = this.resReplaceSubAreaSelectedItems;
    resReplaceDto.ResReplaceCompetencies =
      this.resReplaceEngCompetencySelectedItems;
    resReplaceDto.ResReplaceDepartments = this.resReplaceHRDeptSelectedItems;
    resReplaceDto.ResReplaceCostCenters =
      this.resReplaceCostCenterSelectedItems;
    resReplaceDto.ResReplaceSubServiceLines =
      this.resReplaceSubServiceLineSelectedItems;
    resReplaceDto.ResReplaceManagerialCountries =
      this.resReplaceManageCountrySelectedItems;
    resReplaceDto.ResReplaceCompanyCodes =
      this.resReplaceCompanyCodeSelectedItems;
    resReplaceDto.ResReplaceServiceLines =
      this.resReplaceServiceLineSelectedItems;
    resReplaceDto.ResReplaceEconomicLocations =
      this.resReplaceEcLocationSelectedItems;
    resReplaceDto.RRRC_RInactive = this.resReplaceIsActive;
    resReplaceDto.RRRC_ISDisabled = this.resReplaceIsDisabled;
    resReplaceDto.RRRC_ISLikeEdit = this.resReplaceIsLikeEdit;
    resReplaceDto.RRRC_IV_Disabled = this.resReplaceIndividualView;
    resReplaceDto.RRRC_EV_Disabled = this.resReplaceEngagementView;

    jobReplaceDto.JobReplaceSubAreas = this.jobReplaceSubAreaSelectedItems;
    jobReplaceDto.JobReplaceSubManageUnits =
      this.jobReplaceSubManagementUnitSelectedItems;
    jobReplaceDto.JobReplaceSubServiceLines =
      this.jobReplaceSubServiceLineSelectedItems;
    jobReplaceDto.JobReplaceManagerialCountries =
      this.jobReplaceManageCountrySelectedItems;
    jobReplaceDto.JobReplaceLegalEntities =
      this.jobReplaceLegalEntitySelectedItems;
    jobReplaceDto.JobReplaceCostCenters =
      this.jobReplaceCostCenterSelectedItems;

    jobReplaceDto.JobReplaceCompanyCodes =
      this.jobReplaceCompanyCodeSelectedItems;
    jobReplaceDto.JobReplaceEconomicLocations =
      this.jobReplaceEcoLocationSelectedItems;
    jobReplaceDto.JobReplaceCompetencies =
      this.jobReplaceEngCompetencySelectedItems;

    jobReplaceDto.JobReplaceServiceLines =
      this.jobReplaceServiceLineSelectedItems;
    jobReplaceDto.JobReplaceBusinessUnits =
      this.jobReplaceBusinessUnitSelectedItems;
    jobReplaceDto.JobReplaceJobCategories =
      this.jobReplaceJobCategorySelectedItems;
    jobReplaceDto.JobReplaceJobCode = this.jobReplaceJobCodeSelectedItems;
    jobReplaceDto.JobReplaceIncludeJobCode =
      this.jobReplaceIncludeJobCodeSelectedItems;
    jobReplaceDto.JobReplaceJobStatuses = this.jobReplaceJobStatusSelectedItems;
    jobReplaceDto.JobReplaceJobStatusBookings =
      this.jobReplaceJobStatusBookingSelectedItems;
    jobReplaceDto.RJRC_Learning = this.jobReplaceIsTR;
    jobReplaceDto.RJRC_ISDisabled = this.jobReplaceIsDisabled;
    jobReplaceDto.RJRC_ISLikeEdit = this.jobReplaceIsLikeEdit;
    jobReplaceDto.RJRC_IV_Disabled = this.jobReplaceIndividualView;
    jobReplaceDto.RJRC_EV_Disabled = this.jobReplaceEngagementView;
    // END Replace Configuration

    // Start Replace All  Configuration
    resReplaceAllDto.ResReplaceAllSubAreas =
      this.resReplaceAllSubAreaSelectedItems;
    resReplaceAllDto.ResReplaceAllCompetencies =
      this.resReplaceAllEngCompetencySelectedItems;
    resReplaceAllDto.ResReplaceAllDepartments =
      this.resReplaceAllHRDeptSelectedItems;
    resReplaceAllDto.ResReplaceAllCostCenters =
      this.resReplaceAllCostCenterSelectedItems;
    resReplaceAllDto.ResReplaceAllSubServiceLines =
      this.resReplaceAllSubServiceLineSelectedItems;
    resReplaceAllDto.ResReplaceAllManagerialCountries =
      this.resReplaceAllManageCountrySelectedItems;
    resReplaceAllDto.ResReplaceAllCompanyCodes =
      this.resReplaceAllCompanyCodeSelectedItems;
    resReplaceAllDto.ResReplaceAllServiceLines =
      this.resReplaceAllServiceLineSelectedItems;
    resReplaceAllDto.ResReplaceAllEconomicLocations =
      this.resReplaceAllEcLocationSelectedItems;
    resReplaceAllDto.RRRAC_RInactive = this.resReplaceAllIsActive;
    resReplaceAllDto.RRRAC_ISDisabled = this.resReplaceAllIsDisabled;
    resReplaceAllDto.RRRAC_ISLikeEdit = this.resReplaceAllIsLikeEdit;
    resReplaceAllDto.RRRAC_IV_Disabled = this.resReplaceAllIndividualView;
    resReplaceAllDto.RRRAC_EV_Disabled = this.resReplaceAllEngagementView;

    jobReplaceAllDto.JobReplaceAllSubAreas =
      this.jobReplaceAllSubAreaSelectedItems;
    jobReplaceAllDto.JobReplaceAllSubManageUnits =
      this.jobReplaceAllSubManagementUnitSelectedItems;
    jobReplaceAllDto.JobReplaceAllSubServiceLines =
      this.jobReplaceAllSubServiceLineSelectedItems;
    jobReplaceAllDto.JobReplaceAllManagerialCountries =
      this.jobReplaceAllManageCountrySelectedItems;
    jobReplaceAllDto.JobReplaceAllLegalEntities =
      this.jobReplaceAllLegalEntitySelectedItems;
    jobReplaceAllDto.JobReplaceAllCostCenters =
      this.jobReplaceAllCostCenterSelectedItems;

    jobReplaceAllDto.JobReplaceAllCompanyCodes =
      this.jobReplaceAllCompanyCodeSelectedItems;
    jobReplaceAllDto.JobReplaceAllEconomicLocations =
      this.jobReplaceAllEcoLocationSelectedItems;
    jobReplaceAllDto.JobReplaceAllCompetencies =
      this.jobReplaceAllEngCompetencySelectedItems;

    jobReplaceAllDto.JobReplaceAllServiceLines =
      this.jobReplaceAllServiceLineSelectedItems;
    jobReplaceAllDto.JobReplaceAllBusinessUnits =
      this.jobReplaceAllBusinessUnitSelectedItems;
    jobReplaceAllDto.JobReplaceAllJobCategories =
      this.jobReplaceAllJobCategorySelectedItems;
    jobReplaceAllDto.JobReplaceAllJobCode =
      this.jobReplaceAllJobCodeSelectedItems;
    jobReplaceAllDto.JobReplaceAllIncludeJobCode =
      this.jobReplaceAllIncludeJobCodeSelectedItems;
    jobReplaceAllDto.JobReplaceAllJobStatuses =
      this.jobReplaceAllJobStatusSelectedItems;
    jobReplaceAllDto.JobReplaceAllJobStatusBookings =
      this.jobReplaceAllJobStatusBookingSelectedItems;
    jobReplaceAllDto.RJRAC_Learning = this.jobReplaceAllIsTR;
    jobReplaceAllDto.RJRAC_ISDisabled = this.jobReplaceAllIsDisabled;
    jobReplaceAllDto.RJRAC_ISLikeEdit = this.jobReplaceAllIsLikeEdit;
    jobReplaceAllDto.RJRAC_IsPended = this.jobReplaceAllIsPended;
    jobReplaceAllDto.RJRAC_IV_Disabled = this.jobReplaceAllIndividualView;
    jobReplaceAllDto.RJRAC_EV_Disabled = this.jobReplaceAllEngagementView;
    // END Replace All Configuration

    resEditDto.ResEditSubAreas = this.resEditSubAreaSelectedItems;
    resEditDto.ResEditCompetencies = this.resEditEngCompetencySelectedItems;
    resEditDto.ResEditDepartments = this.resEditHRDeptSelectedItems;
    resEditDto.ResEditCostCenters = this.resEditCostCenterSelectedItems;
    resEditDto.ResEditSubServiceLines = this.resEditSubServiceLineSelectedItems;
    resEditDto.ResEditManagerialCountries =
      this.resEditManageCountrySelectedItems;
    resEditDto.ResEditCompanyCodes = this.resEditCompanyCodeSelectedItems;
    resEditDto.ResEditServiceLines = this.resEditServiceLineSelectedItems;
    resEditDto.ResEditEconomicLocations = this.resEditEcLocationSelectedItems;
    resEditDto.RREC_RInactive = this.resEditIsActive;
    resEditDto.RREC_ISDisabled = this.resEditIsDisabled;
    resEditDto.RREC_IV_Disabled = this.resEditIndividualView;
    resEditDto.RREC_EV_Disabled = this.resEditEngagementView;

    jobEditDto.JobEditSubAreas = this.jobEditSubAreaSelectedItems;
    jobEditDto.JobEditSubManageUnits =
      this.jobEditSubManagementUnitSelectedItems;
    jobEditDto.JobEditSubServiceLines = this.jobEditSubServiceLineSelectedItems;
    jobEditDto.JobEditManagerialCountries =
      this.jobEditManageCountrySelectedItems;
    jobEditDto.JobEditLegalEntities = this.jobEditLegalEntitySelectedItems;
    jobEditDto.JobEditCompanyCodes = this.jobEditCompanyCodesSelectedItems;
    jobEditDto.JobEditServiceLines = this.jobEditServiceLineSelectedItems;
    jobEditDto.JobEditBusinessUnits = this.jobEditBusinessUnitSelectedItems;
    jobEditDto.JobEditEconomicLocations =
      this.jobEditEconomicLocationSelectedItems;
    jobEditDto.JobEditCompetencies = this.jobEditEconomicLocationSelectedItems;

    jobEditDto.JobEditJobCategories = this.jobEditJobCategorySelectedItems;
    jobEditDto.JobEditJobCode = this.jobEditJobCodeSelectedItems;
    jobEditDto.JobEditIncludeJobCode = this.jobEditIncludeJobCodeSelectedItems;
    jobEditDto.JobEditCostCenters = this.jobEditCostCenterSelectedItems;
    jobEditDto.JobEditJobStatuses = this.jobEditJobStatusSelectedItems;
    jobEditDto.JobEditJobStatusBookings =
      this.jobEditJobStatusBookingSelectedItems;
    jobEditDto.RJEC_Learning = this.jobEditIsTR;
    jobEditDto.RJEC_ISDisabled = this.jobEditIsDisabled;
    jobEditDto.RJEC_IsPended = this.jobEditIsPended;
    jobEditDto.RJEC_IV_Disabled = this.jobEditIndividualView;
    jobEditDto.RJEC_EV_Disabled = this.jobEditEngagementView;

    resViewDto.ResViewSubAreas = this.resViewSubAreaSelectedItems;
    resViewDto.ResViewSubServiceLines = this.resViewSubServiceLineSelectedItems;
    resViewDto.ResViewManagerialCountries =
      this.resViewManageCountrySelectedItems;
    resViewDto.ResViewCompanyCodes = this.resViewCompanyCodeSelectedItems;
    resViewDto.ResViewServiceLines = this.resViewServiceLineSelectedItems;
    resViewDto.ResViewEconomicLocations = this.resViewEcLocationSelectedItems;
    resViewDto.ResViewCompetencies = this.resViewEngCompetencySelectedItems;
    resViewDto.ResViewDepartments = this.resViewHRDeptSelectedItems;
    resViewDto.ResViewCostCenters = this.resViewCostCenterSelectedItems;
    resViewDto.RRVC_RInactive = this.resViewIsActive;

    jobViewDto.JobViewSubAreas = this.jobViewSubAreaSelectedItems;
    jobViewDto.JobViewSubServiceLines = this.jobViewSubServiceLineSelectedItems;
    jobViewDto.JobViewManagerialCountries =
      this.jobViewManageCountrySelectedItems;
    jobViewDto.JobViewLegalEntities = this.jobViewLegalEntitySelectedItems;
    jobViewDto.JobViewCompanyCodes = this.jobViewCompanyCodeSelectedItems;
    jobViewDto.JobViewServiceLines = this.jobViewServiceLineSelectedItems;
    jobViewDto.JobViewBusinessUnits = this.jobViewBusinessUnitSelectedItems;
    jobViewDto.JobViewEconomicLocations =
      this.jobViewEconomicLocationsSelectedItems;
    jobViewDto.JobViewSubManageUnits =
      this.jobViewSubManagementUnitSelectedItems;
    jobViewDto.JobViewCompetencies = this.jobViewCompetenciesSelectedItems;

    jobViewDto.JobViewJobCategories = this.jobViewJobCategorySelectedItems;
    jobViewDto.JobViewJobCode = this.jobViewJobCodeSelectedItems;
    jobViewDto.JobViewIncludeJobCode = this.jobViewIncludeJobCodeSelectedItems;
    jobViewDto.JobViewCostCenters = this.jobViewCostCenterSelectedItems;
    jobViewDto.JobViewJobStatuses = this.jobViewJobStatusSelectedItems;
    jobViewDto.JobViewjobStatusBookings =
      this.jobViewJobStatusBookingSelectedItems;
    jobViewDto.RJVC_Learning = this.jobViewIsTR;
    jobViewDto.RJVC_IsPended = this.jobViewIsPended;

    bookingConfigurationDto.RBC_BIDEWEEK = this.bookingCurrentWeekEdit;
    bookingConfigurationDto.RBC_BIDDWEEK = this.bookingCurrentWeekDelete;
    bookingConfigurationDto.RBC_BIDAWEEK = this.bookingCurrentWeekAdd;
    bookingConfigurationDto.RBC_BIDCWEEK = this.bookingCurrentWeekCopy;
    bookingConfigurationDto.RBC_BIDRWEEK = this.bookingCurrentWeekReplace;
    bookingConfigurationDto.RBC_BIDRAWEEK = this.bookingCurrentWeekReplaceAll;
    bookingConfigurationDto.RBC_BIDDTRNG = this.bookigTrainingEngagementDelete;
    bookingConfigurationDto.RBC_BIDETRNG = this.bookigTrainingEngagementEdit;
    bookingConfigurationDto.RBC_BIDDDELT = this.bookigDisabledDelete;
    bookingConfigurationDto.RBC_BIDEEDIT = this.bookigDisabledEdit;
    bookingConfigurationDto.RBC_BIDCCOPY = this.bookigDisabledCopy;
    bookingConfigurationDto.RBC_BIDRRPLC = this.bookigDisabledReplace;
    bookingConfigurationDto.RBC_BIDRARPLCA = this.bookigDisabledReplaceAll;
    if (this.disableActionsGhostBooking) {
      bookingConfigurationDto.RBC_BIDVGhost = this.bookingDisabledGhostView;
      bookingConfigurationDto.RBC_BIDEGhost = this.bookingDisabledGhostEdit;
      bookingConfigurationDto.RBC_BIDDGhost = this.bookingDisabledGhostDelete;
      bookingConfigurationDto.RBC_BIDCGhost = this.bookingDisabledGhostCopy;
      bookingConfigurationDto.RBC_BIDRGhost = this.bookingDisabledGhostReplace;
    }
    this.role.ResourceAddConfigurationDto = resAddDto; //Add Config
    this.role.ResourceDeleteConfigurationDto = resDeleteDto; //Delete Config
    this.role.ResourceReplaceConfigurationDto = resReplaceDto; //Replace Config
    this.role.ResourceReplaceAllConfigurationDto = resReplaceAllDto; //RepalceAll Config
    this.role.ResourceEditConfigurationDto = resEditDto;
    this.role.ResourceViewConfigurationDto = resViewDto;
    this.role.AssignmentConfigurationDto = assingmentDto;
    this.role.JobAddConfigurationDto = jobAddDto; //Add Config
    this.role.JobDeleteConfigurationDto = jobDeleteDto; //Delete Config
    this.role.JobReplaceConfigurationDto = jobReplaceDto; //Replace Config
    this.role.JobReplaceAllConfigurationDto = jobReplaceAllDto; //Replace Config
    this.role.JobEditConfigurationDto = jobEditDto;
    this.role.JobViewConfigurationDto = jobViewDto;
    this.role.BookingConfigurationDto = bookingConfigurationDto;
    this.role.RoleApprovalConfigurationDtos = this.approvalArrDtoForSubmission;
    this.role.RoleFeatureLevelConfigurationDtos = this.featuresList
      .filter((x) => x.IsSelected)
      .map((item) => {
        return {
          IsExclude: item.IsSelected,
          RFC_F_ID: item.Id,
        };
      });
    // v5
    this.role.RoleReportConfigurationDtos = this.setRoleReportConfigDtoDetails();

    this.restService.submitRoleConfiguration(this.role).subscribe(
      (data) => {
        if (data != null) {
          if (data.customResultId <= 0) {
            this.SaveErrorMessage = data.customException;
            this.customResultId = data.customResultId;
            // window.scroll(0, 0);
            this.onScroll.emit();
          } else {
            this.role.R_ID = data.customResultId;
            let csRole = this.roleTypes.find(
              (x) => x.ID == this.selectedRoleType
            );
            if (csRole != null) {
              this.role.RoleTypeName = csRole.Text;
            }
            this.buttonText = 'Saved';
            this.customResultId = null;
            this.role.Message = 'Role configuration submitted successfully';
    
            this.onScroll.emit();
            this.restService.redirectToEdit(this.role);
          }
          this.errorMessage = '';
          this.isExistsAccessRole = false;
          this.onScroll.emit();
          // window.scroll(0, 0);
        }
      },
      (err) => {
        this.onScroll.emit();
        this.buttonText = 'Submit';
        if (err.status === 500) {
          this.SaveErrorMessage = err.error;
          this.onScroll.emit();
          setTimeout(() => {
            this.SaveErrorMessage = '';
          }, 5000);
        }
      },
      () => {
        this.spinner.hide();
        setTimeout(() => {
          this.buttonText = 'Submit';
          this.onScroll.emit();
           // window.scroll(0, 0);
          }, 2000);
      }
    );
  }

  private setRoleReportConfigDtoDetails():RoleReportConfigurationVM[] 
  {
        let arr : RoleReportConfigurationVM[] = [];
        this.assignmentManageReportSelectedItems.forEach(aa => {
          let obj = new RoleReportConfigurationVM;
          obj.RAC_R_ID = 0,
          obj.RAC_RP_ID = aa.Id
          arr.push(obj);
        });
        return arr;
  }
  
  onKeyPressAccessRole() {
    if (this.isExistsAccessRole == true) {
      this.isExistsAccessRole = false;
    }
  }

  onChangeRoleType() {
    this.managePrioirtyDisable();
    this.manageFeatureLevelConfiguration();
    this.makeDirty();
  }

  onCoWorkerChange() {
    if (this.selectedDelegate && this.selectedCoworkers)
      this.selectedDelegate = false;
    this.makeDirty();
  }

  onDelegateChange() {
    if (this.selectedDelegate && this.selectedCoworkers)
      this.selectedCoworkers = false;
    this.makeDirty();
  }

  onJobAssignmentComponentChange(type) {
    if (type === 'job') {
      this.selectedJobAssignment = !this.selectedJobAssignment;
    } else {
      this.selectedComponent = !this.selectedComponent;
    }
    this.makeDirty();
  }

  onChangeOutCheckAccessRole() {
    if (this.accessRoleName != '') {
      this.restService
        .checkAccessRole(0, this.accessRoleName)
        .subscribe((data) => {
          this.isExistsAccessRole = data;
          this.errorMessage = 'Role Name is already exists';
        });
    }
    this.isExistsAccessRole = false;
    this.errorMessage = '';
    this.makeDirty();
  }

  manageFeatureLevelConfiguration() {
    let csRole = this.roleTypes.find((x) => x.ID == this.selectedRoleType);
    if (csRole != null && csRole.Code == this.roleTypeEnum.ClientServer) {
      this.featuresfilterList = this.featureDataList.filter(
        (x) => x.Code == this.roleTypeEnum.ClientServer
      );
    } else if (
      csRole != null &&
      csRole.Code == this.roleTypeEnum.ResourceAdmin
    ) {
      this.featuresfilterList = this.featureDataList.filter(
        (x) => x.Code == this.roleTypeEnum.ResourceAdmin
      );
    }
    this.featuresList = [];
    this.featuresfilterList?.forEach((element) => {
      if (
        csRole != null &&
        csRole.Code == this.roleTypeEnum.ClientServer &&
        (element.Value === 'BookedTimeReportCSP' ||
          element.Value === 'AvailabilityReportCSP' ||
          element.Value === 'ScheduleView')
      ) {
        //this.featureField = { [`${element.Text}`]: true };
        this.featuresList = this.featuresList.concat({
          Id: element.ID,
          Text: element.ParentName + ' - ' + element.Text,
          IsSelected: true,
        });
      } else if (
        csRole != null &&
        csRole.Code == this.roleTypeEnum.ResourceAdmin &&
        (element.Value === 'ScheduleView' ||
          element.Value === 'AdoptionDashboard' ||
          element.Value === 'ControlsDashboard' ||
          element.Value === 'AuditTrail' ||
          element.Value === 'AvailabilityReport' ||
          element.Value === 'BookedTimeReport' ||
          element.Value === 'ApprovalLayer' ||
          element.Value === 'UpdateResourceEmail')
      ) {
        //this.featureField = { [`${element.Text}`]: true };
        this.featuresList = this.featuresList.concat({
          Id: element.ID,
          Text: element.ParentName + ' - ' + element.Text,
          IsSelected: true,
        });
      } else {
        //this.featureField = { [`${element.Text}`]: false };
        this.featuresList = this.featuresList.concat({
          Id: element.ID,
          Text: element.ParentName + ' - ' + element.Text,
          IsSelected: false,
        });
      }
      // this.featuresList = this.featuresList.concat({
      //   Id: element.ID,
      //   Text: element.Text,
      //   IsSelected:
      // });
    });
  }
  //#endregion
}
